import React from 'react';
import T from 'prop-types';

const SettingsBanner = ({
  title = 'Selections for Mobile Performance Index',
  description = 'Many of the export settings, such as datapoints, geography, and granularity options are pre-selected, specific to each company, for their strong correlation to core company KPIs.',
}) => (
  <div className="settings-banner">
    <h5 className="settings-banner__title">{title}</h5>
    <p className="settings-banner__description">{description}</p>
  </div>
);

SettingsBanner.propTypes = {
  title: T.string,
  description: T.string,
};

export default SettingsBanner;
